module.exports = __webpack_public_path__ + "media/images/novem_qrcode-00d1c0118726e15d9a372c55be0eaf83.png";